export default {
  product_info: 'Info del producto',
  return: 'Volver a las opciones',
};
